import {
  ActionIcon,
  Box,
  Button,
  Flex,
  Grid,
  Group,
  Modal,
  Paper,
  Text,
  TextInput,
  Textarea,
  ThemeIcon,
  Tooltip,
  useMantineTheme,
} from '@mantine/core';
import { IconEdit, IconPlus, IconTrash } from '@tabler/icons';
import React, { useEffect, useState } from 'react';
import { api } from '../../services/master.service';
import { showErrorToast, showSuccessToast } from '../../utilities/Toast';

const Feedback = () => {
  const theme = useMantineTheme();
  const [messageFeedback, setMessageFeedback] = useState(null);
  const [titleFeedback, setTitleFeedback] = useState(null);
  const [openedFeedback, setOpenedFeedback] = useState(false);
  const [feedbacks, setFeedbacks] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [errorTitle, setErrorTitle] = useState('');

  useEffect(() => {
    api.get_feedbacks().then((res) => {
      console.log(res.data.data);
      setFeedbacks(res.data.data);
    });
  }, []);

  useEffect(() => {
    if (messageFeedback !== null || messageFeedback !== '') {
      setErrorMessage('');
    }
    if (titleFeedback !== null || titleFeedback !== '') {
      setErrorTitle('');
    }
  }, [messageFeedback, titleFeedback]);

  const handleDelete = (id) => {
    api.delete_feedback(id).then((res) => {
      console.log(res.data);
      if (res.data.success) {
        showSuccessToast({
          title: 'Success',
          message: res.data.message,
        });
        api.get_feedbacks().then((res) => {
          console.log(res.data.data);
          setFeedbacks(res.data.data);
        });
      } else {
        showErrorToast({
          title: 'Error',
          message: res.data.message,
        });
      }
    });
  };

  const sendFeedback = async () => {
    if (
      titleFeedback !== null &&
      titleFeedback !== '' &&
      messageFeedback !== null &&
      messageFeedback !== ''
    ) {
      let payload = {
        title: titleFeedback,
        description: messageFeedback,
      };
      await api.create_feedback(payload).then((res) => {
        console.log(res.data);
        if (res.data.success) {
          showSuccessToast({
            title: 'Success',
            message: res.data.message,
          });
          setTitleFeedback(null);
          setMessageFeedback(null);
          setOpenedFeedback(false);
          api.get_feedbacks().then((res) => {
            console.log(res.data.data);
            setFeedbacks(res.data.data);
          });
        } else {
          showErrorToast({
            title: 'Error',
            message: res.data.message,
          });
        }
      });
    }
    if (messageFeedback === null || messageFeedback === '') {
      setErrorMessage('Invalid Message');
    }
    if (titleFeedback === null || titleFeedback === '') {
      setErrorTitle('Invalid Title');
    }
  };

  return (
    <Box>
      <Paper
        radius={22}
        p={24}
        mb={20}
        sx={{
          position: 'relative',
          overflow: 'hidden',
          background: `linear-gradient(135deg, ${theme.colors.green[0]}, ${theme.white} 56%, ${theme.colors.gray[0]})`,
          border: `1px solid ${theme.colors.green[1]}`,
          boxShadow: '0 18px 42px rgba(13, 71, 21, 0.08)',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            right: -46,
            top: -72,
            width: 180,
            height: 180,
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(34,197,94,.18), transparent 68%)',
          }}
        />
        <Flex
          align="center"
          justify="space-between"
          gap={14}
          wrap="wrap"
          sx={{ position: 'relative', zIndex: 1 }}
        >
          <Group spacing={12} noWrap>
            <ThemeIcon
              size={54}
              radius={16}
              sx={{
                background: `linear-gradient(135deg, ${theme.colors.brand[7]}, ${theme.colors.brand[5]})`,
                boxShadow: '0 12px 24px rgba(13, 71, 21, 0.18)',
              }}
            >
              <IconEdit size={27} />
            </ThemeIcon>
            <Box>
              <Text fw={900} size={26} color="dark" lh={1.1}>
                Help & Feedback
              </Text>
              <Text size="sm" color="dimmed" mt={5}>
                Share product suggestions, requests, and shopping experience notes.
              </Text>
            </Box>
          </Group>
          <Button
            radius="xl"
            leftIcon={<IconPlus size={16} />}
            onClick={() => {
              setOpenedFeedback(true);
            }}
            sx={{
              flex: '0 0 auto',
              fontWeight: 850,
              background: `linear-gradient(135deg, ${theme.colors.brand[7]}, ${theme.colors.brand[5]})`,
              boxShadow: '0 12px 24px rgba(13, 71, 21, 0.16)',
            }}
          >
            Add Feedback
          </Button>
        </Flex>
      </Paper>

      <Grid gutter={16}>
        {feedbacks.length === 0 && (
          <Grid.Col span={12}>
            <Paper
              radius={24}
              p={34}
              sx={{
                textAlign: 'center',
                background: 'linear-gradient(145deg, rgba(255,255,255,.98), rgba(248,250,252,.92))',
                border: `1px solid ${theme.colors.gray[2]}`,
                boxShadow: '0 16px 38px rgba(15, 23, 42, 0.05)',
              }}
            >
              <ThemeIcon size={78} radius={24} variant="light" color="green" mx="auto">
                <IconEdit size={36} />
              </ThemeIcon>
              <Text fw={900} size={22} mt={18} color="dark">
                No feedback added yet
              </Text>
              <Text size="sm" color="dimmed" mt={8} maw={460} mx="auto">
                Tell us what product you need or what we can improve.
              </Text>
            </Paper>
          </Grid.Col>
        )}
        {feedbacks.map((e, i) => (
          <Grid.Col span={12} key={i}>
            <Paper
              p={18}
              radius={20}
              withBorder
              sx={{
                position: 'relative',
                overflow: 'hidden',
                background: 'linear-gradient(145deg, rgba(255,255,255,.99), rgba(248,250,252,.95))',
                borderColor: theme.colors.gray[2],
                boxShadow: '0 12px 30px rgba(15, 23, 42, 0.05)',
                transition: 'transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease',
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  left: 0,
                  right: 0,
                  top: 0,
                  height: 5,
                  background: `linear-gradient(90deg, ${theme.colors.brand[7]}, ${theme.colors.brand[4]}, ${theme.colors.green[1]})`,
                },
                '&:hover': {
                  transform: 'translateY(-2px)',
                  borderColor: theme.colors.green[2],
                  boxShadow: '0 18px 40px rgba(13, 71, 21, 0.09)',
                },
              }}
            >
              <Flex justify="space-between" align="flex-start" gap={14}>
                <Group spacing={12} align="flex-start" noWrap>
                  <ThemeIcon size={40} radius={14} variant="light" color="green">
                    <IconEdit size={20} />
                  </ThemeIcon>
                  <Box>
                    <Text fw={900} size={17} color="dark" lh={1.25}>
                      {e.title}
                    </Text>
                    <Text size={14} color="dimmed" mt={8} lh={1.55}>
                      {e.description}
                    </Text>
                  </Box>
                </Group>
                <Flex sx={{ flex: '0 0 auto' }}>
                  <Tooltip label="Delete Feedback" color={theme.colors.brand[6]}>
                    <ActionIcon
                      radius="xl"
                      size={34}
                      variant="light"
                      color="red"
                      onClick={() => {
                        handleDelete(e.id);
                      }}
                    >
                      <IconTrash size={15} />
                    </ActionIcon>
                  </Tooltip>
                </Flex>
              </Flex>
            </Paper>
          </Grid.Col>
        ))}
      </Grid>

      <Modal
        opened={openedFeedback}
        onClose={() => {
          setOpenedFeedback(false);
        }}
        radius={22}
        overlayProps={{ blur: 4, opacity: 0.42, color: '#07140b' }}
        styles={{
          content: {
            background: 'linear-gradient(145deg, rgba(255,255,255,.99), rgba(248,250,252,.97))',
            border: `1px solid ${theme.colors.green[1]}`,
            boxShadow: '0 26px 70px rgba(15, 23, 42, .22)',
          },
          header: { borderBottom: `1px solid ${theme.colors.green[1]}` },
          body: { padding: 0 },
        }}
        title={
          <Box px={10}>
            <Flex align={'center'} gap={10}>
              <ThemeIcon radius="xl" color="green" variant="light">
                <IconPlus size={18} />
              </ThemeIcon>
              <Text size={'16px'} fw={900}>
                Add Feedback / Suggest your products
              </Text>
            </Flex>
          </Box>
        }
        size={'760px'}
        centered
      >
        <Box p={20}>
          <TextInput
            mt={5}
            radius="md"
            label={'Title'}
            placeholder="Review/Needed/Suggestion"
            error={errorTitle}
            value={titleFeedback}
            onChange={(event) => setTitleFeedback(event.currentTarget.value)}
          />
          <Textarea
            mt={10}
            radius="md"
            label={'Feedback'}
            placeholder="Message"
            minRows={4}
            error={errorMessage}
            value={messageFeedback}
            onChange={(event) => setMessageFeedback(event.currentTarget.value)}
          />
          <Flex align={'center'} justify={'right'}>
            <Button
              mt={20}
              mb={10}
              radius="xl"
              onClick={sendFeedback}
              sx={{
                fontWeight: 850,
                background: `linear-gradient(135deg, ${theme.colors.brand[7]}, ${theme.colors.brand[5]})`,
                boxShadow: '0 12px 24px rgba(13, 71, 21, 0.16)',
              }}
            >
              Send Feedback
            </Button>
          </Flex>
        </Box>
      </Modal>
    </Box>
  );
};

export default Feedback;
